import React from "react";
import BioCard from "./BioCard";
import VehicleCard from "./VehicleCard";
import PayoutCard from "./PayoutCard";

// Top row of the Driver Breakdown report: three equal cards — driver bio,
// vehicle assignment, and the Eta-Purple payout summary — per the Figma design.
// Uses a CSS grid (inline template so it compiles under this app's Tailwind v1)
// that collapses to a single column on narrow viewports.
const HeaderSection = ({ data, vehicleSvg }) => {
  const driver = data.driver || {};
  const totals = data.totals || {};

  return (
    <section
      className="grid"
      style={{ gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 29 }}>
      <BioCard driver={driver} totalGroupedTrips={totals.grouped_trips || 0} />
      <VehicleCard vehicle={data.vehicle} svg={vehicleSvg} />
      <PayoutCard totals={totals} breakdown={data.platform_breakdown} />
    </section>
  );
};

export default HeaderSection;
